import { Modal, Button, Label, Textarea } from "flowbite-react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { KbSolution } from "@/sharedTypes";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: Partial<KbSolution>) => void;
  mode: "create" | "edit";
  initialData?: KbSolution | null;
  vectorLanguage?: "en" | "tr";
}

export default function KbSolutionFormDialog({
  open,
  onClose,
  onSubmit,
  mode,
  initialData,
  vectorLanguage,
}: Props) {
  const { t } = useTranslation(["knowledgeBase", "common"]);
  const [formData, setFormData] = useState<Partial<KbSolution>>({
    kb_solution_text: "",
  });

  useEffect(() => {
    if (mode === "edit" && initialData) {
      setFormData({
        kb_solution_text: initialData.kb_solution_text,
      });
    } else {
      setFormData({
        kb_solution_text: "",
      });
    }
  }, [mode, initialData, open]);

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Modal show={open} onClose={onClose} size="lg">
      <Modal.Header>
        {mode === "create"
          ? t("knowledgeBase:createSolution")
          : t("knowledgeBase:editSolution")}
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-4">
          {vectorLanguage && (
            <div className="flex items-center gap-2 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-700 dark:border-blue-800 dark:bg-blue-950 dark:text-blue-300">
              <span className="font-medium">{t("knowledgeBase:milvusLanguageLabel")}:</span>
              <span className="rounded bg-blue-100 px-1.5 py-0.5 font-mono text-xs font-semibold uppercase dark:bg-blue-900">
                {vectorLanguage === "en" ? "EN — English" : "TR — Türkçe"}
              </span>
            </div>
          )}
          <div>
            <Label htmlFor="kb_solution_text" value={t("knowledgeBase:solutionText")} />
            <Textarea
              id="kb_solution_text"
              rows={4}
              value={formData.kb_solution_text || ""}
              onChange={(e) =>
                setFormData({ ...formData, kb_solution_text: e.target.value })
              }
              required
            />
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button color="primary" onClick={handleSubmit}>
          {mode === "create" ? t("knowledgeBase:createSolution") : t("common:save")}
        </Button>
        <Button color="gray" onClick={onClose}>
          {t("common:cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
